import PercentLabelDisplay from './PercentLabelDisplay'

export default PercentLabelDisplay
